/**
 * Single source of truth for Algolia attribute names
 * Used across components, hooks, and tests to ensure consistency
 */

export const ALGOLIA_ATTRIBUTES = {
  // Non-localized attributes
  SIZE: 'size',
  PRICE_CENT_AMOUNT: 'price.centAmount',
  CATEGORIES_KEY: 'categories.key',

  // Localized attributes - base names without locale
  FASTENING: 'fastening',
  GENDER: 'gender',
  PRODUCT_TYPE: 'productType',
  BRAND: 'brand',
  TECHNOLOGIES: 'technologies',
  SUB_TECHNOLOGIES: 'subTechnologies',
  UPPER_MATERIAL: 'upperMaterial',
  REVIEW_RATING: 'review.rating',
  FIT: 'fit',
  PRODUCT_SUB_TYPES: 'productSubTypes',
  COLOR: 'color',
  CATEGORIES_NAME: 'categories.name',
  HEEL_HEIGHT_GROUPS: 'heelHeight.groups',
  STYLE_NAME: 'styleName',
} as const;

type AlgoliaAttributes = typeof ALGOLIA_ATTRIBUTES;
export type AlgoliaAttributeValue = AlgoliaAttributes[keyof AlgoliaAttributes];
